// extracted by mini-css-extract-plugin
export default {"tipo":"TablaLinks_tipo__zHzQB","fecha":"TablaLinks_fecha__O83zQ","link":"TablaLinks_link__xKonm"};